var map = {
	"./colfactura/Icono almacenamiento.svg": 757,
	"./colnomina/Icono almacenamiento.svg": 758,
	"./firmamail/Icono almacenamiento.svg": 759,
	"./firmaya/Icono almacenamiento.svg": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 756;